function testimonials(name, autoplay, interval) {
    document.querySelectorAll(name).forEach(carousel => new Splide(carousel, {
        autoplay: autoplay,
        interval: interval,
        pauseOnHover: true
    }).mount());
}